/**
 * Локальный уникальный ID для optimistic pending-элементов (upload queue,
 * picker-выбор, повтор запроса) — `${prefix}-${seed}-${timestamp}-${random}`.
 * Формат стабилен намеренно: id попадает в React `key` и в сравнения, менять
 * его нельзя.
 */
export function makeLocalId(prefix: string, seed: string): string {
    return `${prefix}-${seed}-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
